"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";
import { FaWallet } from "react-icons/fa";
import { useSignOut } from "@/lib/hooks/use-auth";
import { cn } from "@/lib/utils";
import { BsFillCartCheckFill } from "react-icons/bs";
import { MdLockReset } from "react-icons/md";
import { TbGridDots } from "react-icons/tb";
import { HOME_PAGE, ROUTES } from "@/lib/constants";
import { IoSettings } from "react-icons/io5";

export const navItems = [
  {
    name: "Dashboard",
    href: HOME_PAGE,
    icon: TbGridDots,
  },
  {
    name: "Orders",
    href: `${HOME_PAGE}/orders`,
    icon: BsFillCartCheckFill,
  },
  {
    name: "Wallet & Payments",
    href: `${HOME_PAGE}/wallet`,
    icon: FaWallet,
  },
  {
    name: "Settings",
    href: ROUTES.SETTINGS,
    icon: IoSettings,
  },
  // {
  //   name: "Chats",
  //   href: `${HOME_PAGE}/chats`,
  //   icon: BsChatTextFill,
  // },
];
export default function DashboardSidebar() {
  const pathname = usePathname();
  const { signOut } = useSignOut();

  const isActive = (href: string) => {
    if (href === HOME_PAGE) {
      return pathname === HOME_PAGE;
    }
    return pathname.startsWith(href);
  };

  const SidebarContent = () => (
    <aside className="bg-white font-mulish flex flex-col justify-between h-full">
      {/* Navigation Items */}
      <nav className="px-4 py-7">
        <ul className="space-y-3">
          {navItems.map((item) => {
            const active = isActive(item.href);

            return (
              <li key={item.name}>
                <Link
                  href={item.href}
                  className={cn(
                    "flex group items-center gap-3 whitespace-nowrap px-4 py-2 rounded-lg transition-colors",
                    active
                      ? "text-primary bg-primary/10 font-bold font-pt-sans text-lg"
                      : "text-muted-light hover:text-primary SidebarAction",
                  )}
                >
                  <div className="flex relative items-center justify-center size-8 shrink-0 [&_svg]:size-6">
                    <item.icon />
                  </div>
                  <span>{item.name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Logout Button */}
      <div className="px-4 mb-6 border-gray-200">
        <button
          onClick={() => {
            signOut();
          }}
          className="flex items-center gap-3 px-4 py-3 w-full text-muted-light hover:text-destructive rounded-lg SidebarAction"
        >
          <MdLockReset size={28} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );

  return (
    <aside className="hidden lg:flex w-64 bg-white border-r font-mulish border-gray-200 flex-col">
      <SidebarContent />
    </aside>
  );
}
